import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { Button } from '@material-ui/core';

import Status from 'retired/Status';
import {
  statusError,
  statusDisabled,
  statusTextSuccess,
  statusTextError,
  statusTextDisabled,
  red,
  statusNeutral,
  statusTextNeutral,
  gray2,
  lightGray,
} from 'utils/color-styles';
import TimeCircleIcon from 'assets/icons/time-circle.svg';
import InfoSquareRed from 'assets/icons/info-square-red.svg';
import Img from 'retired/Img';
import EditIcon from 'assets/icons/edit.svg';

export interface DonationPayrollStatusProps {
  status: 'Deducted' | 'Pending' | 'Failure' | 'Processed';
  id?: string;
  executionErrorMessage: string;
  canRescheduleDonation?: boolean;
  rescheduledTo?: string;
  setSelectedDonation?: (id: string) => void;
}

// @TODO-AS move to the component library

export const DonationPayrollStatus = ({
  status,
  id,
  executionErrorMessage,
  canRescheduleDonation,
  rescheduledTo,
  setSelectedDonation,
}: DonationPayrollStatusProps): JSX.Element => {
  if (status === 'Failure') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span
          title={executionErrorMessage}
          style={{ visibility: rescheduledTo ? 'hidden' : 'visible' }}
        >
          <WarningIcon style={{ color: red, marginRight: 10 }} />
        </span>

        <Status
          title={rescheduledTo ? 'Rescheduled' : 'Unsuccessful'}
          color={rescheduledTo ? statusNeutral : statusError}
          textColor={rescheduledTo ? statusTextNeutral : statusTextError}
          icon={InfoSquareRed}
          style={{ marginLeft: 8 }}
        />
        {canRescheduleDonation && (
          <Button
            variant="outlined"
            size="small"
            style={{ color: gray2, borderColor: lightGray, marginLeft: 10 }}
            onClick={(e): void => {
              e.preventDefault();
              if (setSelectedDonation && id) {
                setSelectedDonation(id);
              }
            }}
          >
            Edit
            <Img src={EditIcon} alt="Edit" style={{ marginLeft: 12, width: 12, height: 12 }} />
          </Button>
        )}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex' }}>
      <Status
        title={status}
        color={statusDisabled}
        textColor={
          ['Deducted', 'Processed'].includes(status) ? statusTextSuccess : statusTextDisabled
        }
        icon={TimeCircleIcon}
        style={{ marginLeft: 38 }}
      />
    </div>
  );
};

export default DonationPayrollStatus;
